import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SEASON_ENTRY_FEE } from '../utils/constants';
import { currentYear } from '../utils/date';
import Announcement from './Announcement';
import { PaymentOptions } from './entries/PaymentOptions';

function Home({ user, setNextPage, setShowLogin, suppressAnnouncement }) {
    const [showAnnouncement, setShowAnnouncement] = useState(true);
    const navigate = useNavigate();
    const handleSubmitPicks = () => {
        if (!user) {
            setNextPage('/entries');
            setShowLogin(true);
        } else {
            navigate('/entries');
        }
    };

    useEffect(() => {
        setShowAnnouncement(!suppressAnnouncement);
    }, [suppressAnnouncement]);

    return (
        <div>
            <Announcement show={showAnnouncement} setShow={setShowAnnouncement} />
            <div className="container col-xxl-8 px-4 py-5">
                <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
                    <div className="col-10 col-sm-8 col-lg-6">
                        <img src="/banner_image.jpg" className="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700" height="500" loading="lazy"></img>
                    </div>
                    <div className="col-lg-6">
                        <h1 className="display-5 fw-bold lh-1 mb-3">Buckeye Pick'em is back!</h1>
                        <p className="lead">We're ready to go for {currentYear()}!</p>
                        <p><sub>Go Irish!</sub></p>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-center py-2">
                            <button type="button" className="btn btn-primary btn-lg px-4 me-md-2" onClick={handleSubmitPicks}>Submit Your Picks</button>
                        </div>
                    </div>
                </div>
                <div className="row py-4">
                    <div className="col">
                        <h1 className="text-center text-danger fw-bold">FREQUENTLY ASKED QUESTIONS</h1>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col">
                        <h3>When can I submit my picks?</h3>
                        <p className="lead">Picks can be entered between 10:00 a.m. US Eastern on Tuesday morning and 10:00 a.m. US Eastern on Saturday morning.
                        If you want to pick a weekday game, your entire entry must be submitted prior to the start time of that game.</p>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col">
                        <h3>Where can I see the picks of the entire field?</h3>
                        <p className="lead">The picks will be posted on the results page on Saturday morning @ 10:00 a.m. after the submission deadline has ended.</p>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col">
                        <h3>What if a game is cancelled?</h3>
                        <p className="lead">Covid, hurricanes, wildfires... if your game gets canceled or postponed to later in the season, it will count as a non-game on your entry. I highly recommend selecting 6 games per entry. See the next section for detailed RULES & REGS.</p>
                    </div>
                </div>
                <div className="row py-4">
                    <div className="col">
                        <h1 id="rules" className="text-center text-danger fw-bold">PICK'EM RULES & REGS</h1>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col">
                        <p className="lead">Each year we lose and gain a few members, spread the word and invite your degenerate friends and family members to join us for Year 24 of College Football Pick 'em!</p>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col">
                        <ul>
                            <li>Each week the complete listing of the college point spreads will be posted and locked in on the website (www.buckeyepickem.com). Picks get posted on Monday or Tuesday night.</li>
                            <li>For each entry you play, you will select 5 or 6 (your choice) winning teams using the point spreads posted.</li>
                            <li>To win the pot you must have a perfect 5-0 or 6-0 record.</li>
                            <li>A push is a loss.</li>
                            <li>A 6-0 beats a 5-0 entry.</li>
                            <li>Multiple winners? Split the pot.</li>
                            <li>If no one is perfect for the week all money rolls over to the following week.</li>
                            <li>Every week is 100% payout!</li>
                            <li>If a game has not been assigned a point spread on Tuesday, but one surfaces by Thursday AM, the spread might be posted on the site and available.</li>
                            <li>Each entry is $5 per week. Must prepay to play. ${SEASON_ENTRY_FEE} covers the entire season including the bowls. Play up to 10 entries per week (${SEASON_ENTRY_FEE}, ${2 * SEASON_ENTRY_FEE}...)</li>
                            <li>Send your entry fees to Phil Schoch (pronounced "Scotch" like the tape):
                                <PaymentOptions />
                            </li>
                            <li>Please do not wait until the last minute to submit your entry. Excessive traffic on the site can cause log-in delays. If this happens try again a few minutes later.</li>
                            <li>If you are picking a weeknight game, your picks must be submitted before kickoff.</li>
                            <li>Your weekly entries must be submitted by Saturday morning @ 10:00 AM US Eastern. No late entries will be accepted into the website. Late entries will NOT be added, but…</li>
                            <li>If you miss the deadline, you will have the opportunity to ‘double up’ the following week.</li>
                            <li>COVID, wildfire or weather issues: Buyer beware! If your game gets canceled or postponed due to COVID, wildfires, hurricanes, tornadoes, or the mob cuts the power to the stadium… this counts as a non-game on your entry. If a last minute Covid outbreak or hurricane sabotages your 5-teamer and you only have 4 games for your entry, you are not eligible to win the pot! Substitute entries can not be entered. I recommend you pick six games per entry.</li>
                            <li>If you have questions, please email me at osuphil95@yahoo.com or text me at (SixOneFour) 352-6979.</li>
                        </ul>
                    </div>
                </div>
                <div className="row py-4">
                    <div className="col">
                        <h1 className="text-center text-danger fw-bold">FAKE GOOD LUCK!</h1>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;